import { useEffect, useMemo, useRef, useState } from 'react';

export default function SearchableSelect({ label, value, onChange, items = [] }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const containerRef = useRef(null);

  const selected = items.find((item) => item.code === value);

  useEffect(() => {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setQuery('');
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter(
      (item) => item.name.toLowerCase().includes(q) || item.code.toLowerCase().includes(q)
    );
  }, [items, query]);

  function pick(code) {
    onChange(code);
    setOpen(false);
    setQuery('');
  }

  return (
    <div className="relative" ref={containerRef}>
      <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
      <input
        value={open ? query : selected ? selected.name : ''}
        placeholder="All"
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        className="border border-gray-300 rounded px-2 py-1.5 text-sm min-w-[160px] w-full"
      />
      {open && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-auto bg-white border border-gray-200 rounded shadow-lg">
          <button
            type="button"
            onClick={() => pick('')}
            className="block w-full text-left px-3 py-1.5 text-sm hover:bg-gray-50 text-gray-500"
          >
            All
          </button>
          {filtered.length === 0 ? (
            <div className="px-3 py-1.5 text-sm text-gray-400">No matches</div>
          ) : (
            filtered.slice(0, 200).map((item) => (
              <button
                type="button"
                key={item.code}
                onClick={() => pick(item.code)}
                className={`block w-full text-left px-3 py-1.5 text-sm hover:bg-gray-50 ${
                  item.code === value ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                }`}
              >
                {item.name}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
